import React, { useEffect, useState } from 'react';
import Select, { SingleValue } from '../AccessSelect';
import { Tooltip } from '@mui/material';

import TrashButton from '../../modules/TrashButton';
import { ACCESS_TYPE } from '../../../enums/ACCESS_ENUM';
import { USER_SHARE_OPTIONS } from '../MyFolderPage/ShareFolderModal/UserList';
import { FILE_ACCESS_TYPE, FILE_ACCESS_TYPE_SHARED_WITH_ME_WITH_SUBGROUP } from '../../../enums';

type TUsersList = {
  onNewOrganizationAccessChange?: (access: SingleValue<{ value: string; label: ACCESS_TYPE }>, downloadPermission?: boolean) => void;
  onOrganizationDelete: (accessId: string) => void;
  orgAccess?: FILE_ACCESS_TYPE | FILE_ACCESS_TYPE_SHARED_WITH_ME_WITH_SUBGROUP;
  css: any;
  orgDownloadPermission?: boolean;
  onOrgDownloadPermissionChange?: () => void;
};

const AllUsersList: React.FC<TUsersList> = ({
  orgAccess,
  onNewOrganizationAccessChange,
  onOrganizationDelete,
  css,
  orgDownloadPermission,
  onOrgDownloadPermissionChange,
}) => {
  const [firstLoad, setFirstLoad] = useState(false);

  useEffect(() => {
    if (!firstLoad) {
      setFirstLoad(true);
    } else if (orgAccess && onNewOrganizationAccessChange) {
      onNewOrganizationAccessChange({ value: orgAccess.access.title, label: '...' as ACCESS_TYPE }, orgDownloadPermission);
    }
  }, [orgDownloadPermission]);

  return (
    <div className={css.list}>
      <div className={css.listItem}>
        <div className={css.user}>
          <div className={css.userInfo}>All Users</div>

          <div className={css.selectorContainer}>
            <Select
              isSearchable={false}
              defaultValue={
                orgAccess ? USER_SHARE_OPTIONS.find((option) => option.value === orgAccess.access.title) : USER_SHARE_OPTIONS[2]
              }
              styles={{
                control: (baseStyles) => ({
                  ...baseStyles,
                  background: '#525252',
                  border: '1px solid #DBDBDB',
                  borderRadius: '4px',
                  color: '#DBDBDB',
                  height: '24px',
                  padding: '0 8px',
                }),
              }}
              options={USER_SHARE_OPTIONS}
              unstyled
              className={css.customSelector}
              classNamePrefix="select"
              name="access"
              onChange={(e) => onNewOrganizationAccessChange?.(e)}
              menuPosition={'fixed'}
            />
          </div>

          {onOrgDownloadPermissionChange && <div className={css.allowDownloadCheckbox}>
            <div className={css.checkboxWrapper30}>
              <div className={css.allowDownloadCheckboxText}>
                Allow
                <br />
                Downloads?
              </div>
              <span className={css.checkbox}>
                <input type="checkbox" onChange={onOrgDownloadPermissionChange} checked={orgDownloadPermission} />
                <svg>
                  <use xlinkHref="#checkbox-30" className={css.checkbox}></use>
                </svg>
              </span>
              <svg xmlns="http://www.w3.org/2000/svg" style={{ display: 'none' }}>
                <symbol id="checkbox-30" viewBox="0 0 22 22">
                  <path
                    fill="none"
                    stroke="currentColor"
                    d="M5.5,11.3L9,14.8L20.2,3.3l0,0c-0.5-1-1.5-1.8-2.7-1.8h-13c-1.7,0-3,1.3-3,3v13c0,1.7,1.3,3,3,3h13 c1.7,0,3-1.3,3-3v-13c0-0.4-0.1-0.8-0.3-1.2"
                  />
                </symbol>
              </svg>
            </div>
          </div>}

          <div className={css.removeBtn}>
            <Tooltip title={'Delete'}>
              <TrashButton small onClick={onOrganizationDelete} />
            </Tooltip>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllUsersList;
